import { useState, useEffect, useRef, Fragment } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    Autocomplete,
    Tooltip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Box,
    Snackbar,
    Alert
} from '@mui/material';
import { Breadcrumb } from 'components';
import {
    getInventoryList,
    updateInventory,
    getInternalUserDespatchLocations
} from 'services';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

export default function BottleOrderPage() {
    const [paginationModel, setPaginationModel] = useState({
        page: 1,
        total: 0,
        data: [],
        isLoading: false
    });
    const [despatchLocation, setDespatchLocation] = useState([]);
    const [selectedDespatchLocation, setSelectedDespatchLocation] = useState<any>(null);
    const [selectedDespatchLocationId, setSelectedDespatchLocationId] = useState<number | string | null>(null);
    const [tabIndex, setTabIndex] = useState(0);
    const [snackOpen, setSnackOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [appliedSearch, setAppliedSearch] = useState('');

    const containerRows = (paginationModel.data || []).filter((x: any) => x?.isPackage === false);
    const packageRows = (paginationModel.data || []).filter((x: any) => x?.isPackage === true);

    const jwt: any = localStorage.getItem('token');
    const labUserCheck: any = jwt ? JSON.parse(atob(jwt.split('.')[1])) : null;


    const filteredContainerRows = containerRows.filter((x: any) =>
        (x?.containerName ?? '').toLowerCase().includes(appliedSearch.toLowerCase())
    );
    const filteredPackageRows = packageRows.filter((x: any) =>
        (x?.packageName ?? '').toLowerCase().includes(appliedSearch.toLowerCase())
    );
    const currentRows = tabIndex === 0 ? filteredContainerRows : filteredPackageRows;

    const getInventoryColumns = (isPackageTab: boolean) => ([
        {
            field: isPackageTab ? 'packageName' : 'containerName',
            headerName: isPackageTab ? 'Package Name' : 'Container Name',
            minWidth: 200
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            minWidth: 200
        },
        {
            field: 'action',
            headerName: 'Action',
            minWidth: 150,
        }
    ]);

    const inventoryTableColumn = getInventoryColumns(tabIndex === 1);

    useEffect(() => {
        if (labUserCheck?.UserType === 'Internal') {
            getDespatchLocation();
        }
    }, []);

    const getDespatchLocation = async () => {
        const res: any = await getInternalUserDespatchLocations();
        if (res && res.status === 200 && res.data.length > 0) {
            setDespatchLocation(res.data);

            // default select first item
            const firstLocation = res.data[0];
            setSelectedDespatchLocation(firstLocation);
            setSelectedDespatchLocationId(firstLocation?.id ?? null);

            if (firstLocation?.id) {
                fetchInventoryList(firstLocation.id);
            }
        } else {
            setDespatchLocation([]);
            setSelectedDespatchLocation(null);
            setSelectedDespatchLocationId(null);
        }
    };

    useEffect(() => {
        if (labUserCheck?.UserType === 'Internal' && selectedDespatchLocationId) {
            fetchInventoryList(selectedDespatchLocationId);
        }
    }, [selectedDespatchLocationId]);

    const fetchInventoryList = async (id: any) => {
        setPaginationModel((prev) => ({ ...prev, isLoading: true }));
        const res: any = await getInventoryList(id);
        if (res && res.status === 200) {
            setPaginationModel((prev) => ({
                ...prev,
                data: res.data,
                total: res.data.length,
                isLoading: false
            }));
        } else {
            setPaginationModel((prev) => ({ ...prev, isLoading: false }));
        }
    }

    const updateInventoryApi = async (row: any) => {
        let obj = {
            "id": row.id,
            "quantity": row.quantity,
        }
        const res: any = await updateInventory(obj);
        if (res && res.status === 200) {
            fetchInventoryList(selectedDespatchLocationId);
            setSnackOpen(true);
        } else {
            //handle error
        }
    }

    const handleUpdateRow = (event: React.ChangeEvent<HTMLInputElement>, row: any) => {
        const value = event.target.value;
        setPaginationModel((prev: any) => ({
            ...prev,
            data: (prev.data || []).map((item: any) =>
                item.id === row.id
                    ? { ...item, quantity: value === '' ? '' : Number(value) }
                    : item
            )
        }));
    };

    let intenalUserCheck = (labUserCheck?.Permission?.includes('StandardQuotes') || labUserCheck?.Permission === 'StandardQuotes') ? '/home/viewQuote' : '/home/admin';

    let pathChange = (labUserCheck && (labUserCheck?.UserType === 'Internal')) ? intenalUserCheck : '/home';

    let nav: any = [{ name: 'Home', path: pathChange }, { name: 'Order History', path: '/home/orderHistory' }, { name: 'Inventory List', path: '/home/inventory' }];

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0', cursor: 'pointer' }}>
                <Breadcrumb navList={nav} />
            </div>
            <Typography variant="h6" gutterBottom align='left' mb={2}>
                Inventory List
            </Typography>
            <Grid container spacing={2} alignItems="center" mb={4}>
                <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                        options={despatchLocation}
                        value={selectedDespatchLocation}
                        getOptionLabel={(option: any) => option?.name ?? ''}
                        isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                        onChange={(_, value: any) => {
                            setSelectedDespatchLocation(value);
                            setSelectedDespatchLocationId(value?.id ?? null);
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Dispatch Location" size="small" />
                        )}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center" mb={2} style={{ backgroundColor: '#f5f5f5', marginLeft: '0px', padding: '16px', borderRadius: '6px', width: '100%' }}>
                <Grid item xs={12} sm={6} md={4} style={{ padding: '0px 8px' }}>
                    <TextField
                        label={tabIndex === 0 ? 'Search by Container Name' : 'Search by Package Name'}
                        size="small"
                        fullWidth
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4} style={{ padding: '0px 8px' }}>
                    <Button
                        variant="contained"
                        onClick={() => setAppliedSearch(searchTerm)}
                        startIcon={<ContentPasteSearchOutlinedIcon />}
                    >
                        Search
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            setSearchTerm('');
                            setAppliedSearch('');
                        }}
                        startIcon={<ClearOutlinedIcon />}
                        sx={{ ml: 2 }}
                    >
                        Clear All
                    </Button>
                </Grid>
            </Grid>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)}>
                    <Tab label="Containers" />
                    <Tab label="Quality & Packing" />
                </Tabs>
            </Box>

            <Grid container spacing={2} mt={2}>
                <Grid item xs={12} sm={12} md={12}>
                    <TableContainer
                        sx={{
                            borderRadius: '4px',
                            overflow: 'hidden',
                            border: '1px solid #ddd',
                            mt: 2
                        }}
                    >
                        <Table sx={{ minWidth: 700 }} aria-label="simple table">
                            <TableHead style={{ backgroundColor: 'rgb(0, 56, 131)' }}>
                                <TableRow style={{ height: '50px' }}>
                                    {inventoryTableColumn.map((col) => (
                                        <TableCell
                                            key={col.field}
                                            style={{ color: '#fff', padding: '4px', minWidth: col.minWidth }}
                                        >
                                            {col.headerName}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {currentRows.length > 0 ? (
                                    currentRows.map((row: any) => (
                                        <Fragment key={row.id}>
                                            <TableRow tabIndex={-1}>
                                                <TableCell style={{ padding: '8px 10px' }}>{tabIndex === 0 ? row.containerName : row.packageName}</TableCell>
                                                <TableCell style={{ padding: '8px 10px' }}>
                                                    <TextField
                                                        id="outlined-basic"
                                                        name="quantity"
                                                        label=""
                                                        sx={{
                                                            '.MuiOutlinedInput-input': {
                                                                width: '75px',
                                                                padding: '8px 10px',
                                                                fontSize: '12px'
                                                            }
                                                        }}
                                                        variant="outlined"
                                                        size="small"
                                                        type="number"
                                                        inputProps={{ min: 0 }}
                                                        value={row.quantity ?? ''}
                                                        onChange={(event: any) => {
                                                            const val = event.target.value;
                                                            if (val === '' || Number(val) >= 0) {
                                                                handleUpdateRow(event, row);
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell style={{ padding: '8px 10px' }}>
                                                    <Button variant="contained" onClick={() => updateInventoryApi(row)} startIcon={<SaveOutlinedIcon />}>
                                                        Save
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        </Fragment>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={inventoryTableColumn.length} align="center" style={{ padding: '16px' }}>
                                            No data available
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
            <Snackbar
                open={snackOpen}
                autoHideDuration={3000}
                onClose={() => setSnackOpen(false)}
            >
                <Alert severity="success" onClose={() => setSnackOpen(false)} sx={{ width: '100%' }}>
                    <b>Successfully updated</b>
                </Alert>
            </Snackbar>
        </div>
    );
}
